// extracted by mini-css-extract-plugin
module.exports = {"modal":"_15RJ5-SZ","message":"_16K_7TOZ","message-bold":"_1NDoh3Wx","actions":"_2zMs8HBE"};